import { useGameStore } from '../stores/gameStore'
import './SidePanel.css'

export function SidePanel() {
  const { currentView, setView } = useGameStore()

  const menuItems = [
    { id: 'map', label: '天下大势', icon: '🗺️' },
    { id: 'internal', label: '内政管理', icon: '🏛️' },
    { id: 'talent', label: '招贤纳士', icon: '👤' },
  ] as const

  return (
    <div className="side-panel">
      <nav className="main-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${currentView === item.id ? 'active' : ''}`}
            onClick={() => setView(item.id)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
      
      <div className="panel-footer">
        <div className="faction-info">
          <h3>齐国</h3>
          <p>国君：姜小白</p>
          <p>都城：临淄</p>
        </div>
      </div>
    </div>
  )
}
